module.exports = __webpack_public_path__ + "img/cup.ed08eb29.png";